<mat-toolbar *ngIf="hasToolbar && !isAsync" color="accent">
  <button id="goToPanelButtonShowEdit" mat-icon-button (click)="goToPanel()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span>{{ 'signature.title' | translate }}</span>
</mat-toolbar>

<mat-card *ngIf="responseOK">
  <h2>{{ 'request.header.title' | translate }} {{ numOperation }}</h2>
  <div class="content">
    <mat-icon class="icon-ic_circle_check" color="accent"></mat-icon>
    <p class="title">{{ 'signature.response.ok' | translate }}</p>
    <p class="text">{{ 'signature.response.GUID' | translate }}{{ guid }}</p>
  </div>
</mat-card>

<mat-card *ngIf="!responseOK">
  <h2>{{ 'request.header.title' | translate }} {{ numOperation }}</h2>
  <div class="content">
    <mat-icon class="icon-ic_circle_cross" color="accent"></mat-icon>
    <p class="title">{{ 'signature.response.cancel' | translate }}</p>
    <p class="text">{{ 'signature.response.GUID' | translate }}{{ guid }}</p>
    <p>{{ 'signature.response.cancel.message' | translate }}</p>
  </div>
</mat-card>
